export default __webpack_public_path__ + "static/media/mines1.c5086609.jpg";